module.exports = __webpack_public_path__ + "static/media/7.647c20b8.jpg";